import React, { useState, useContext } from "react";
import Header from "../components/Header";
import Cards from "../components/Cards";
import { Image, Form } from "react-bootstrap";
import Context from "../Context";
import CardFotoInforme from "../components/informes/CardFotoInforme";

const PlanCorrectivo = () => {
  const { showLogo, showIcons } = useContext(Context);

  const localPosturaCorrectiva = JSON.parse(
    localStorage.getItem("localPosturaCorrectiva")
  );
  const [posturaCorrectiva, setPosturaCorrectiva] = useState(
    localPosturaCorrectiva
  );

  const localPosturaGlobal = JSON.parse(
    localStorage.getItem("localPosturaGlobal")
  );
  const [posturaGlobal, setPosturaGlobal] = useState(localPosturaGlobal);

  const handlePosturaCorrectiva = (event) => {
    const inputValue = event.target.value;
    setPosturaCorrectiva(inputValue);

    localStorage.setItem("localPosturaCorrectiva", JSON.stringify(inputValue));
  };

  const handlePosturaGlobal = (event) => {
    const inputValue = event.target.value;
    setPosturaGlobal(inputValue);

    localStorage.setItem("localPosturaGlobal", JSON.stringify(inputValue));
  };

  const handleDeleteAll = () => {
    setPosturaCorrectiva("");
    setPosturaGlobal("");

    localStorage.removeItem("localPosturaCorrectiva", "localPosturaGlobal");
  };
  return (
    <>
      <section id="planCorrectivo">
        {showLogo && (
          <Image
            className="logoPDF"
            src="./assets/images/cmf-logo.png"
            alt="logo cmf"
          />
        )}
        <Header title="Plan Correctivo" />

        <div className="wraper-cards">
          <div className="column">
            {showIcons && (
              <h4 className="text-center mb-perso color-background">""</h4>
            )}
            {showLogo && (
              <h4 className="text-center mb-perso text-white">""</h4>
            )}
            <div className="card-section">
              <div style={{ /*  width: 400, */ margin: 20 }}>
                <h4 className="text-center">Plan Correctivo</h4>
                <br />

                <h6 className="mt-2">Postura Correctiva</h6>
                <Form.Control
                  as="textarea"
                  placeholder="Escriba aquí..."
                  value={posturaCorrectiva}
                  onChange={handlePosturaCorrectiva}
                />

                <h6 className="mt-2">Postura Global</h6>
                <Form.Control
                  as="textarea"
                  placeholder="Escriba aquí..."
                  value={posturaGlobal}
                  onChange={handlePosturaGlobal}
                />
              </div>
            </div>
            {showIcons && (
              <div className="icons-card-canvas mb-5">
                <img
                  className="icon-trash-canvas"
                  src="/assets/images/trash.png"
                  alt="icon-image"
                  onClick={handleDeleteAll}
                />
                {/* <img
            className="icon-trash-canvas"
            src="/assets/images/icon-download.png"
            alt="icon-image"
            onClick={() => alert("Imagen guardada")}
          /> */}
              </div>
            )}
          </div>

          <CardFotoInforme title="Postura Correctiva" htmlFor="fileUpload9" />

          <CardFotoInforme title="Postura Global" htmlFor="fileUpload10" />
        </div>
      </section>
    </>
  );
};

export default PlanCorrectivo;
